import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import amplitudeAnalytics from '../../shared/utilities/amplitude';

const AmplitudeUserSync = () => {
  const userId = useSelector((state) => state.user?.userId);

  useEffect(() => {
    amplitudeAnalytics.syncUserId(userId);
  }, [userId]);

  return null;
};

export default AmplitudeUserSync;
